module.exports = __webpack_public_path__ + "static/media/ki.db9ce4a8.svg";